import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div style={{
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      backgroundColor: "#f8f9fa",
      direction: "rtl",
    }}>
      <h1 style={{ fontSize: "6rem", marginBottom: 0 }}>404</h1>
      <p style={{ fontSize: "1.5rem", marginBottom: "1.5rem" }}>
        אוי! הדף שחיפשת לא נמצא.
      </p>
      <Link to="/home" style={{
        backgroundColor: "#0d6efd",
        color: "white",
        padding: "0.75rem 1.5rem",
        borderRadius: "0.5rem",
        textDecoration: "none",
        fontSize: "1rem",
        fontWeight: "bold"
      }}>
        חזור לדף הבית
      </Link>
    </div>
  );
};

export default NotFound;
